import { Dispatch } from 'redux';

import { Venues, LandingPages, BarnPage, LandingPagesApi, VendorsApi, BarnVenueApi } from '@weddingspot/ws-api-client';

import * as constants from '../constants';
import * as types from '../types';

export interface LoadLandingPageData {
    type: constants.LOAD_LANDING_PAGE_DATA;
    payload: LandingPages.LandingPageData;
}

export interface LoadLandingPageRecommendedVenues {
    type: constants.LOAD_LANDING_PAGE_RECOMMENDED_VENUES;
    payload: (Venues.VenueDetails | Venues.UnlistedVenueDetails)[];
}

export interface LandingPageLoaded {
    type: constants.LANDING_PAGE_LOADED;
}

export interface LoadBarnPageData {
    type: constants.LOAD_BARN_PAGE_DATA;
}

export type LandingPagesAction = LoadLandingPageData | LoadLandingPageRecommendedVenues | LandingPageLoaded | LoadBarnPageData;

export function loadLandingPageData(path: string): (dispatch: Dispatch<LoadLandingPageData>) => Promise<LandingPages.LandingPageData> {
    return function (dispatch: Dispatch<LoadLandingPageData>) {
        return LandingPagesApi.getLandingPageData(path).then((res) => {
            dispatch({
                type: constants.LOAD_LANDING_PAGE_DATA,
                payload: res,
            });
            return res;
        });
    };
}

export function loadLandingPageRecommendedVenues(venueIds: number[]) {
    return function (dispatch: Dispatch<LoadLandingPageRecommendedVenues>) {
        return VendorsApi.venueDetailsBulk(venueIds).then((res) => {
            dispatch({
                type: constants.LOAD_LANDING_PAGE_RECOMMENDED_VENUES,
                payload: res,
            });
            return res;
        });
    };
}

export function loadBarnPageData(params: { bucket: string; market: string; region: string; count?: number }) {
    return function (dispatch: Dispatch<LoadBarnPageData>) {
        return BarnVenueApi.getBarnPageData(params).then((res: any) => {
            dispatch({
                type: constants.LOAD_BARN_PAGE_DATA,
                payload: res,
            });
            return res;
        });
    };
}

export function loadCuratedListPageData(params: {
    bucket: string;
    market: string;
    region: string;
    count?: number;
    style?: string;
}): (dispatch: Dispatch<LoadBarnPageData>) => Promise<BarnPage.BarnPageData> {
    return function (dispatch: Dispatch<LoadBarnPageData>) {
        return BarnVenueApi.getBarnPageData(params).then((res: any) => {
            dispatch({
                type: constants.LOAD_BARN_PAGE_DATA,
                payload: res,
            });
            return res;
        });
    };
}

export function landingPageLoaded(): (dispatch: Dispatch<LandingPageLoaded>) => void {
    return function (dispatch: Dispatch<LandingPageLoaded>) {
        dispatch({ type: constants.LANDING_PAGE_LOADED });
    };
}
